import React from 'react';
import withTermsQuery from 'utils/withTermsQuery';

const PageProjekti = (props) => {
  const PageWithTerms = withTermsQuery(
    'projekti',
    [
      'projekti_tags',
      'projektu_joma',
      'projektu_statuss',
    ],
    props.lang,
    [
      'projekti',
      'projekta_joma',
      'visas_projektu_jomas',
      'projekta_statuss',
      'visi_projektu_statusi',
      'temas',
      'visas_temas',
      'satur_vardus',
      'atpakal',
      'talak',
      'no',
    ],
    10,
    'menu_order',
    'asc'
  );
  return <PageWithTerms {...props} />
}

export default PageProjekti;



// WEBPACK FOOTER //
// ./src/components/PageProjekti.js